import React from 'react';

import { Typography } from 'lighthouse';

import { MedalStar, ShieldTick, Truck, Wallet3 } from 'iconsax-react';

export const TRUST_ITEMS = [
    { icon: ShieldTick, label: 'ضمانت اصالت کالا' },
    { icon: MedalStar, label: 'گارانتی رسمی' },
    { icon: Wallet3, label: 'پرداخت امن' },
    { icon: Truck, label: 'ارسال و نصب‌ سریع' }
];

export const TrustBadges = () => {
    return (
        <div className='grid grid-cols-4 gap-1 rounded-lg border border-solid border-gray-100 bg-gray-50 p-2'>
            {TRUST_ITEMS.map(({ icon: Icon, label }) => (
                <div key={label} className='flex flex-col items-center gap-1.5 py-1 text-center'>
                    <Icon color='currentcolor' className='size-5 text-primary' variant='Bold' />
                    <Typography variant='caption' className='text-[10px] leading-tight text-blackMediumEmphasis'>
                        {label}
                    </Typography>
                </div>
            ))}
        </div>
    );
};
